import React from 'react';
const RightsidebarGreybox = ({ className }) => {
  return (
    <div className={`right-greybox ${className}`}>
      <div className='first-box'></div>
      <div className='second-box'></div>
      <div className='third-box'></div>
    </div>
  );
};

export default RightsidebarGreybox;
